import { createUIIcon } from '@mono-activities/ui'

import * as iconTypes from './icons'

const { UIIcon, isIcon } = createUIIcon(iconTypes)

export type UIIconType = keyof typeof iconTypes
export type UIIconRef = SVGSVGElement
export { isIcon }
export default UIIcon
